import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PDialogFooterBtnActionType, PDialogFooterBtnConfig } from './p-dialog-footer-btn-config.interface';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'p-dialog-footer',
    template: `
        <footer class="p-dialog-footer">
            <div class="p-content-wrapper">
                <ng-content></ng-content>
            </div>
            <ng-container *ngFor="let btn of btnConfig; trackBy: trackByFn; index as i">
                <p-button
                    *ngIf="btn.type == dialogBtnActionType.Close"
                    [attr.automation-id]="'cancel_btn'"
                    label="{{ btn.text || cancelText | translate }}"
                    [large]="true"
                    [buttonType]="buttonTypes[i]"
                    [isSentenceCase]="btn.isCamelCase ? false : true"
                    class="dialog-cancel-button p-dialog-footer-btn"
                    mat-dialog-close
                    [disabled]="btn.disabled ?? false"
                >
                </p-button>
                <p-button
                    *ngIf="btn.type != dialogBtnActionType.Close"
                    [attr.automation-id]="btn.automationId || automationId || btn.text"
                    [label]="(btn.text ? btn.text : '') | translate"
                    [isSentenceCase]="btn.isCamelCase ? false : true"
                    [large]="true"
                    [buttonType]="btn.type == dialogBtnActionType.Destructive ? buttonType.Destructive : buttonTypes[i]"
                    class="p-dialog-footer-btn"
                    [class]="btn.className"
                    (buttonClicked)="btn?.click()"
                    [disabled]="btn.disabled ?? (btn.disabled$ && btn.disabled$ | async) ?? false"
                    [matTooltip]="btn.tooltip || ''"
                    [matTooltipPosition]="btn.tooltipPosition || 'below'"
                >
                </p-button>
            </ng-container>
        </footer>
    `,
    styleUrls: ['./p-dialog-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PDialogFooterComponent {
    buttonType = ButtonTypeEnum;
    @Input() disabled = false;
    @Input() btnConfig: PDialogFooterBtnConfig[] = [];
    @Input() buttonTypes: ButtonTypeEnum[] = [ButtonTypeEnum.Primary, ButtonTypeEnum.Secondary, ButtonTypeEnum.Tertiary];
    @Input() automationId?: string;
    dialogBtnActionType = PDialogFooterBtnActionType;
    cancelText = 'Actions.cancel';

    trackByFn(index: number) {
        return index;
    }
}
